(function () {
  'use strict';

  // ── Gallery Nav (desktop: left thumbnail nav + vertical scroll) ──────────

  function initGalleryNav() {
    if (!window.matchMedia('(min-width: 750px)').matches) return;

    const mediaGallery = document.querySelector('.product-information__media media-gallery');
    if (!mediaGallery) return;

    // 2026-07-13: DOM部分再描画でギャラリーがラッパー外に再挿入された場合の自己修復。
    // 現在のmedia-galleryを包んでいる正常なラッパーがあれば何もしない。
    // 包んでいない古いラッパーが残っていれば除去して作り直す。
    const existingLayout = document.querySelector('.navero-gallery-layout');
    if (existingLayout) {
      if (existingLayout.contains(mediaGallery)) return;
      existingLayout.remove();
    }

    const grid = mediaGallery.querySelector('.media-gallery__grid');
    if (!grid) return;

    const items = Array.from(grid.querySelectorAll('.product-media-container'));
    if (items.length <= 1) return;

    const mediaData = [];
    items.forEach(function (li) {
      const productMedia = li.querySelector('[data-media-id]');
      if (!productMedia) return;
      const mediaId = productMedia.dataset.mediaId;
      const img = li.querySelector('img.product-media__image');
      if (!mediaId || !img) return;
      li.id = 'navero-media-' + mediaId;
      mediaData.push({ mediaId: mediaId, li: li, img: img });
    });

    if (mediaData.length <= 1) return;

    const nav = document.createElement('nav');
    nav.className = 'navero-gallery-nav';
    nav.setAttribute('aria-label', '商品画像サムネイル');

    mediaData.forEach(function (item, index) {
      const a = document.createElement('a');
      a.href = '#navero-media-' + item.mediaId;
      a.className = 'navero-gallery-nav__thumb';
      a.dataset.mediaId = item.mediaId;

      if (index === 0) {
        a.setAttribute('aria-current', 'true');
        a.classList.add('is-active');
      }

      const thumbImg = document.createElement('img');
      // 2026-08-12 パフォーマンス修正：メイン画像のsrc（?width=3840）を流用していたため、
      // 64px表示のサムネイル1枚で約594KBを読み込んでいた（200px幅なら約16KB）。
      thumbImg.src = /([?&])width=\d+/.test(item.img.src)
        ? item.img.src.replace(/([?&])width=\d+/, '$1width=200')
        : item.img.src + (item.img.src.indexOf('?') === -1 ? '?' : '&') + 'width=200';
      thumbImg.alt = item.img.alt || '';
      thumbImg.width = 64;
      thumbImg.height = 96; // 2026-07-13 縦長2:3
      thumbImg.loading = 'lazy';
      a.appendChild(thumbImg);

      a.addEventListener('click', function () {
        document.querySelectorAll('.navero-gallery-nav__thumb').forEach(function (t) {
          t.removeAttribute('aria-current');
          t.classList.remove('is-active');
        });
        a.setAttribute('aria-current', 'true');
        a.classList.add('is-active');
      });

      nav.appendChild(a);
    });

    const wrapper = document.createElement('div');
    wrapper.className = 'navero-gallery-layout';
    mediaGallery.parentNode.insertBefore(wrapper, mediaGallery);
    wrapper.appendChild(nav);
    wrapper.appendChild(mediaGallery);

    const intersectingItems = new Set();

    function updateActiveThumb() {
      if (intersectingItems.size === 0) return;
      const topmost = mediaData.find(function (d) { return intersectingItems.has(d.li); });
      if (!topmost) return;
      document.querySelectorAll('.navero-gallery-nav__thumb').forEach(function (t) {
        const match = t.dataset.mediaId === topmost.mediaId;
        if (match) {
          t.setAttribute('aria-current', 'true');
          t.classList.add('is-active');
        } else {
          t.removeAttribute('aria-current');
          t.classList.remove('is-active');
        }
      });
    }

    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) { intersectingItems.add(entry.target); }
          else { intersectingItems.delete(entry.target); }
        });
        updateActiveThumb();
      },
      { root: null, threshold: 0.5, rootMargin: '-10% 0px -10% 0px' }
    );

    mediaData.forEach(function (d) { observer.observe(d.li); });
  }

  // ── Mobile Gallery Thumbs ─────────────────────────────────────────────────

  function initMobileGallery() {
    if (!window.matchMedia('(max-width: 749px)').matches) return;

    const mediaGallery = document.querySelector('media-gallery');
    if (!mediaGallery) return;

    if (mediaGallery.querySelector('.navero-mobile-gallery-thumbs')) return;

    const grid = mediaGallery.querySelector('.media-gallery__grid');
    if (!grid) return;

    const items = Array.from(grid.querySelectorAll('.product-media-container'));
    if (items.length <= 1) return;

    const mediaData = [];
    items.forEach(function (li) {
      const productMedia = li.querySelector('[data-media-id]');
      const img = li.querySelector('img.product-media__image');
      if (!productMedia || !img) return;
      mediaData.push({ img: img });
    });

    if (mediaData.length <= 1) return;

    // Build thumbnail strip
    const thumbsContainer = document.createElement('div');
    thumbsContainer.className = 'navero-mobile-gallery-thumbs';

    const thumbButtons = [];
    let currentActiveIndex = 0;

    function keepActiveThumbVisible(index) {
      var btn = thumbButtons[index];
      if (!btn || !thumbsContainer) return;
      var btnCenter = btn.offsetLeft + btn.offsetWidth / 2;
      var targetLeft = btnCenter - thumbsContainer.clientWidth / 2;
      thumbsContainer.scrollTo({ left: Math.max(0, targetLeft), behavior: 'smooth' });
    }

    function updateActiveThumb(index) {
      if (index === currentActiveIndex && thumbButtons[index] &&
          thumbButtons[index].classList.contains('is-active')) return;
      currentActiveIndex = index;
      thumbButtons.forEach(function (btn, i) {
        btn.classList.toggle('is-active', i === index);
      });
      keepActiveThumbVisible(index);
    }

    mediaData.forEach(function (item, index) {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'navero-mobile-gallery-thumb';
      btn.setAttribute('aria-label', 'Image ' + (index + 1));
      if (index === 0) btn.classList.add('is-active');

      const thumbImg = document.createElement('img');
      // 2026-08-12 パフォーマンス修正：メイン画像のsrc（?width=3840）を流用していたため、
      // 64px表示のサムネイル1枚で約594KBを読み込んでいた（200px幅なら約16KB）。
      thumbImg.src = /([?&])width=\d+/.test(item.img.src)
        ? item.img.src.replace(/([?&])width=\d+/, '$1width=200')
        : item.img.src + (item.img.src.indexOf('?') === -1 ? '?' : '&') + 'width=200';
      thumbImg.alt = item.img.alt || '';
      thumbImg.width = 56;
      thumbImg.height = 72;
      thumbImg.loading = 'lazy';
      btn.appendChild(thumbImg);

      btn.addEventListener('click', function () {
        const slideshowEl = mediaGallery.querySelector('slideshow-component');
        if (slideshowEl && typeof slideshowEl.select === 'function') {
          slideshowEl.select(index);
          return;
        }
        const dots = mediaGallery.querySelectorAll(
          'slideshow-controls.media-gallery__mobile-controls .slideshow-controls__dots button'
        );
        if (dots[index]) {
          dots[index].click();
        }
      });

      thumbButtons.push(btn);
      thumbsContainer.appendChild(btn);
    });

    // Append at the end of media-gallery to avoid being clipped inside slideshow-component
    mediaGallery.appendChild(thumbsContainer);

    // Active state: MutationObserver on dot buttons
    const dots = Array.from(
      mediaGallery.querySelectorAll(
        'slideshow-controls.media-gallery__mobile-controls .slideshow-controls__dots button'
      )
    );

    if (dots.length > 0) {
      const mutObserver = new MutationObserver(function () {
        const activeIdx = dots.findIndex(function (d) {
          return d.getAttribute('aria-selected') === 'true';
        });
        if (activeIdx >= 0) updateActiveThumb(activeIdx);
      });
      dots.forEach(function (dot) {
        mutObserver.observe(dot, { attributes: true, attributeFilter: ['aria-selected'] });
      });
    }

    // Active state: IntersectionObserver on slideshow-slide (fallback)
    const slides = Array.from(mediaGallery.querySelectorAll('slideshow-slide'));
    if (slides.length > 0) {
      const ioObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              const idx = slides.indexOf(entry.target);
              if (idx >= 0) updateActiveThumb(idx);
            }
          });
        },
        { threshold: 0.5 }
      );
      slides.forEach(function (slide) { ioObserver.observe(slide); });
    }
  }

  // ── Sticky Details ────────────────────────────────────────────────────────

  function initStickyDetails() {
    if (!window.matchMedia('(min-width: 750px)').matches) return;

    const details = document.querySelector('.product-details.sticky-content--desktop');
    if (!details) return;
    if (details.dataset.naveroStickyInit) return;
    details.dataset.naveroStickyInit = '1';

    function getHeaderHeight() {
      const h = parseFloat(
        getComputedStyle(document.body).getPropertyValue('--header-height')
      );
      return Number.isFinite(h) && h > 0 ? h : 60;
    }

    function updateStickyTop() {
      const headerH = getHeaderHeight();
      const bottomGap = 16;
      const detailsH = details.scrollHeight;
      const availableH = window.innerHeight - headerH - bottomGap;

      if (detailsH > availableH) {
        const topPx = window.innerHeight - detailsH - bottomGap;
        details.style.setProperty('--navero-details-sticky-top', topPx + 'px');
      } else {
        details.style.removeProperty('--navero-details-sticky-top');
      }
    }

    updateStickyTop();

    details.querySelectorAll('details').forEach(function (accordion) {
      accordion.addEventListener('toggle', function () {
        requestAnimationFrame(updateStickyTop);
        setTimeout(updateStickyTop, 250);
        setTimeout(updateStickyTop, 500);
      });
    });

    if ('ResizeObserver' in window) {
      new ResizeObserver(updateStickyTop).observe(details);
    }

    window.addEventListener('resize', updateStickyTop, { passive: true });
  }

  // ── Reveal on scroll（控えめなフェードアップ・進行的強化）──────────────────
  // 進行的強化：JS無効/失敗時・reduced-motion時はCSS初期非表示が適用されず常に表示。
  // 対象は下方の要素のみ（上部の商品名/価格はロード時チラつき回避のため対象外）。
  var revealDone = false;
  function initReveal() {
    if (revealDone) return;
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var els = [];
    document.querySelectorAll('.product-details .accordion, product-recommendations, .product-recommendations')
      .forEach(function (el) { if (els.indexOf(el) === -1) els.push(el); });
    if (els.length === 0) return;

    revealDone = true;
    document.documentElement.classList.add('navero-reveal-on');

    var ioAlive = false;
    var io = new IntersectionObserver(function (entries) {
      ioAlive = true; // IOが生きている証明（初回コールバックは非交差でも必ず来る）→安全網を解除
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('nvr-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });

    els.forEach(function (el) {
      el.setAttribute('data-navero-reveal', '');
      io.observe(el);
    });

    // 安全網：IOが不発の環境でのみ 1.2s 後に全表示（2026-07-07修正：従来は無条件＝ゆっくりスクロールで演出が再生されなかった）。
    setTimeout(function () {
      if (!ioAlive) els.forEach(function (el) { el.classList.add('nvr-in'); });
    }, 1200);
  }

  // ── Bootstrap ─────────────────────────────────────────────────────────────

  function handleGalleryBreakpointChange() {
    requestAnimationFrame(function () {
      initGalleryNav();
      initMobileGallery();
      initStickyDetails();
    });
  }

  var desktopMql = window.matchMedia('(min-width: 750px)');
  var mobileMql = window.matchMedia('(max-width: 749px)');
  desktopMql.addEventListener('change', handleGalleryBreakpointChange);
  mobileMql.addEventListener('change', handleGalleryBreakpointChange);

  window.addEventListener('resize', function () {
    clearTimeout(window.__naveroGalleryResizeTimer);
    window.__naveroGalleryResizeTimer = setTimeout(handleGalleryBreakpointChange, 150);
  }, { passive: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initGalleryNav();
      initMobileGallery();
      initStickyDetails();
      initReveal();
    });
  } else {
    initGalleryNav();
    initMobileGallery();
    initStickyDetails();
    initReveal();
  }
})();
